module.exports = __webpack_public_path__ + "img/PY.5537bc9e.png";